ko.bindingHandlers.summernote = {
    init: function(element, valueAccessor, allBindingsAccessor) {

        var underlyingObservable = valueAccessor();

        var interceptor = ko.computed({
            read: function() {
                return underlyingObservable
                    ? ko.isObservable(underlyingObservable)
                    ? underlyingObservable()
                    : underlyingObservable
                    : null;
            },

            write: function(newValue) {
                var current = underlyingObservable();

                if (newValue !== current) {
                    underlyingObservable(newValue);
                    underlyingObservable.valueHasMutated();
                }
            }
        });

        var options = allBindingsAccessor().summernoteOptions ||
        {
            height: 150,
            dialogsInBody: true,
            toolbar: [
                ["style", ["bold", "italic", "underline", "clear"]],
                ["font", ["strikethrough", "superscript", "subscript"]],
                ["fontsize", ["fontsize"]],
                ["color", ["color"]],
                ["para", ["ul", "ol", "paragraph"]],
                ["height", ["height"]],
                ["link", ["link"]]
            ]
        };

        options.contents = underlyingObservable();
        options.lang = "pt-BR";

        options.callbacks = {
            onChange: function(contents, $editable) {
                var o = valueAccessor();
                if (ko.isObservable(o)) {
                    o(contents);
                }
            }
        };

        var $el = $(element);
        $(".note-editor", $el.parent()).remove();
        $el.summernote('destroy')
        $el.summernote(options);
        $el.summernote("code", underlyingObservable());

        ko.applyBindingsToNode(element, { value: interceptor });

    }

};